import { HTMLAttributes } from 'react'
import { useMediaQueries } from 'builder/hooks/useMediaQueries'

import NoResumeImg from './assets/noResume.png'
import NoResumeMobileImg from './assets/noResume-mobile.png'
import * as Styles from './styles'

type IlustrationBoxProps = HTMLAttributes<HTMLDivElement> & {
  score: number
  background: string
  scoreText?: string
  resumePreview?: string
}

export const IlustrationBox = ({
  score,
  background,
  scoreText,
  resumePreview,
  ...props
}: IlustrationBoxProps) => {
  const { isPhone } = useMediaQueries()
  const image = resumePreview || (isPhone ? NoResumeMobileImg : NoResumeImg)

  return (
    <Styles.IlustrationContainer {...props}>
      <Styles.ImageContainer $isPreview={!!resumePreview}>
        <Styles.Image src={image} />
        {!!score && isPhone && (
          <Styles.ScoreContainer data-testid="resume-score-progress">
            <Styles.Score $background={background}>{score}%</Styles.Score>
            <Styles.ScoreText>{scoreText}</Styles.ScoreText>
          </Styles.ScoreContainer>
        )}
      </Styles.ImageContainer>
      {!!score && !isPhone && (
        <Styles.ScoreContainer data-testid="resume-score-progress">
          <Styles.Score $background={background}>{score}%</Styles.Score>
          <Styles.ScoreText>{scoreText}</Styles.ScoreText>
        </Styles.ScoreContainer>
      )}
      {!!resumePreview && <Styles.IlustrationOverlay $score={score} />}
    </Styles.IlustrationContainer>
  )
}
